import { Button } from "@chakra-ui/react"
import { FC, ReactElement, ReactNode } from "react"

interface FilterChipProps {
  isActive: boolean
  onClick: () => void
  children: ReactNode
  leftIcon?: ReactElement
}

// Пилюля фильтра: выбранная — залитая синим, остальные — контурные
export const FilterChip: FC<FilterChipProps> = ({ isActive, onClick, children, leftIcon }) => (
  <Button
    size="sm"
    borderRadius="full"
    fontWeight="medium"
    colorScheme={isActive ? "blue" : "gray"}
    variant={isActive ? "solid" : "outline"}
    leftIcon={leftIcon}
    onClick={onClick}
  >
    {children}
  </Button>
)
